/* 🤖 this file was generated by svg-to-ts */
export const siriusMagnifyingGlassDuotone: {
  name: 'magnifying_glass_duotone';
  data: string;
} = {
  name: 'magnifying_glass_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M10.875 18.75a7.875 7.875 0 1 0 0-15.75 7.875 7.875 0 0 0 0 15.75Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.875 2.25a8.625 8.625 0 1 0 5.546 15.231l4.049 4.05a.75.75 0 1 0 1.06-1.061l-4.049-4.05a8.625 8.625 0 0 0-6.606-14.17ZM3.75 10.875a7.125 7.125 0 1 1 14.25 0 7.125 7.125 0 0 1-14.25 0Z" fill="currentColor"/></svg>`
};
